/**
 * Where an edited text saves. Its id is "<subitemId>_<field>", or
 * "<field>_<subitemId>" when the first part is not a number.
 */
export const saveTargetOf = (id: string) => {
  const [part1, part2] = id.split('_');
  const startsWithId = !isNaN(Number(part1));
  return {
    subitemId: startsWithId ? part1 : part2,
    field: startsWithId ? part2 : part1
  };
};
